<style lang="less" scoped>
.tip-contain {
    position: absolute;
    top: 20px;
    left: -170px;
    
}
  .expense-wrapper{
    margin: 10px 0;
    padding-left: 10px;
    border-left: 3px solid #2b85e4;
  }
  .reimbursement-menu-btn {
    position: fixed;
    top: 66px;
    left: 16px;
  }
</style>
<template>
  <div ref="contain">
    <VModal
      v-model="config.modal"
      :loading="config.loading"
      :content-loading="loading"
      fullscreen
      ok-text="保存"
      @ok="updateExpenseGroup"
    >
      <EditHeader
        slot="header"
        :expense_group="edit_expense_group"
      />
      <v-menu
        v-if="type===8"
        v-model="reimbursement_menu"
        :close-on-click="false"
        :close-on-content-click="false"
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="reimbursement-menu-btn"
            color="indigo"
            dark
            v-bind="attrs"
            v-on="on"
          >
            发票登记信息
          </v-btn>
        </template>

        <v-card style="padding: 20px 20px 0 20px">
          <InvoiceRegisterInfo 
            :info="edit_expense_group.expense_register"
          />
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              text
              @click="reimbursement_menu = false"
            >
              关闭
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
      <v-menu
        v-if="edit_expense_group.reimbursement"
        v-model="reimbursement_menu"
        :close-on-click="false"
        :close-on-content-click="false"
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="reimbursement-menu-btn"
            color="indigo"
            dark
            v-bind="attrs"
            v-on="on"
          >
            显示报销信息
          </v-btn>
        </template>

        <v-card style="padding: 20px 20px 0 20px">
          <ReimbursementInfo :reimbursement="edit_expense_group.reimbursement" />
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              text
              @click="reimbursement_menu = false"
            >
              关闭
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>

      <v-form
        ref="form"
        v-model="data_valid"
        :disabled="loading"
        style="max-width: 800px; margin: 0 auto;position:relative"
      >
        <!-- <div
          v-if="show_blog_tips"
          class="tip-contain"
        >
          <BlogTips :value="edit_expense_group" />
        </div> -->
        <v-row>
          <v-col>
            <VCustomerSelector
              v-model="edit_expense_group.apply_user_id"
              :rules="[v => v > 0 || '申请人不能为空']"
              :disabled="!can_edit"
              label="申请人"
              @change="setApplyUser"
            />
          </v-col>
          <v-col>
            <v-text-field
              :value="edit_expense_group.uid || '保存后自动生成'"
              label="单据编号"
              disabled
            />
          </v-col>
          <v-col>
            <v-text-field
              :value="edit_expense_group.fill_user"
              label="填制人"
              disabled
            />
          </v-col>
          <v-col>
            <v-text-field
              :value="getFillTime(edit_expense_group)"
              label="填制时间"
              disabled
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-text-field
              v-model="edit_expense_group.name"
              :rules="[v => !!v || '单据名称不能为空', $rule.length({max: 50})]"
              :counter="50"
              label="单据名称"
              placeholder="请简要描述事项"
            />
          </v-col>
          <v-col cols="3">
            <v-select
              v-model="edit_expense_group.company_id"
              :rules="[v => v > 0 || '请选择公司']"
              :items="companies"
              item-text="short_name"
              item-value="id"
              label="公司"
              placeholder="该业务合同签署的公司"
              @change="companyChange"
            />
          </v-col>
          <v-col cols="3">
            <VTeamSelector
              v-model="edit_expense_group.team_id"
              :rules="[v => v > 0 || '请选择团队']"
              label="团队"
              placeholder="费用所属团队"
            />
          </v-col>
        </v-row>
        <v-row v-if="need_pay">
          <v-col
            v-if="!is_accrual_repair"
            cols="3"
          >
            <v-select
              v-model="edit_expense_group.currency"
              :items="currencies"
              :item-text="(c) => (`${c.symbol}-${c.label}`)"
              :disabled="!can_edit"
              label="付款币别"
              placeholder="请选择币别"
            />
          </v-col>
          <v-col
            v-if="type === 2"
            cols="3"
          >
            <VDatePicker
              v-model="edit_expense_group.expect_reverse_at"
              label="预计冲账日期"
            />
          </v-col>
          <v-col
            v-if="is_financer"
            cols="3"
          >
            <v-checkbox
              v-model="edit_expense_group.is_simple"
              label="简易付款"
            />
          </v-col>
          <v-col
            v-if="is_financer"
            cols="3"
          >
            <v-checkbox
              v-model="edit_expense_group.can_cross_company"
              label="是否可以跨公司付款"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            v-if="edit_expense_group.payment_type === 1"
            cols="3"
          >
            <v-checkbox
              v-model="edit_expense_group.has_stocks"
              :disabled="!can_edit"
              label="是否为采购类付款"
            />
          </v-col>
          <v-col
            v-if="can_link_outsource_contract"
          >
            <v-checkbox
              v-model="edit_expense_group.is_outsource"
              :disabled="!can_edit"
              label="是否为兼职外包付款"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            v-if="can_link_contract"
            cols="6"
          >
            <VContractSelector
              v-model="edit_expense_group.contract_id"
              :rules="[v => v > 0 || '请关联合同']"
              label="关联合同"
              @change="selectConctract"
            />
          </v-col>
          <v-col
            v-if="edit_expense_group.is_outsource"
            cols="3"
          >
            <v-select
              v-model="edit_expense_group.kind"
              :rules="[v => kind_values.includes(v) || '请选择']"
              :items="kinds"
              item-text="label"
              item-value="value"
              label="兼职外包付款平台"
              placeholder="付款平台..."
              @change="edit_expense_group.outsource_contract_id = 0"
            />
          </v-col>
          <v-col
            v-if="edit_expense_group.is_outsource"
            cols="6"
          >
            <VOutsourceContractSelector
              v-model="edit_expense_group.outsource_contract_id"
              :rules="[v => v > 0 || '请关联']"
              :platform="edit_expense_group.kind"
              label="关联兼职外包合同"
            />
          </v-col>
          <v-col
            v-if="edit_expense_group.payment_type === 0"
            cols="6"
          >
            <VAdvanceSelector
              v-model="edit_expense_group.advance_id"
              :extra-date="{company_id: edit_expense_group.company_id}"
              label="关联预支单"
            />
          </v-col>
        </v-row>
        <v-row v-if="is_financer">
          <v-col
            v-if="need_pay"
            cols="6"
          >
            <VBankSelector
              v-model="edit_expense_group.expense_payment_bank_id"
              :rules="[v => v > 0 || '请选择付款账户']"
              :can-cross-company="edit_expense_group.can_cross_company"
              :check-payment-fin-bill="[0, 1].includes(payment_type)"
              :company-id="edit_expense_group.company_id"
              label="我方账户"
              :placeholder="edit_expense_group.payment_bank_number || '请选择我方付款账户'"
              @change="setBank"
            />
          </v-col>
          <v-col
            v-if="need_pay"
            cols="3"
          >
            <VDatePicker
              v-model="edit_expense_group.paid_at"
              label="付款日期"
              placeholder="CBS/云账户无需填写"
            />
          </v-col>
          <v-col cols="3">
            <VDatePicker
              v-model="edit_expense_group.verified_at"
              :disabled="is_period_closed"
              label="入账会计期"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="9">
            <VPayeeAccountSelector
              v-model="edit_expense_group.payee_bank_number"
              :rules="[v => !!v || '请选择收款账户']"
              :type="payee_type"
              :clearable="true"
              :item-text="vpayeeaccountselector_item_text"
              :apply_user_id="edit_expense_group.apply_user_id"
              label="收款账户"
              :placeholder="payee_account_info"
              @change="setPayeeAccount"
              :findKey="payeeFindKey"
              :noDataText="payeeNoDataText"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            v-if="is_type_9"
            cols="3"
          >
            <v-select
              v-model="edit_expense_group.currency"
              :items="currencies_remote"
              :item-text="(c) => (`${c.symbol}-${c.name}`)"
              label="币别"
              item-value="code"
              :rules="[val=>{
                return ![null,undefined,''].includes(val) || '必选'
              }]"
              placeholder="请选择币别"
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              :value="total_price"
              label="总金额（原币）"
              :rules="[validTotal]"
              readonly
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-if="is_type_9"
              v-model="edit_expense_group.cny_total_price"
              label="总金额（人民币）"
              :rules="[val=>{
                return ![null,undefined,''].includes(val) || '必填'
              }]"
            />
          </v-col>
        </v-row>
        <v-row v-if="can_link_return_bill">
          <v-col cols="6">
            <VReturnSelector
              v-model="edit_expense_group.return_expense_group_id"
              clearable
              label="关联退款原单"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-textarea
              v-model="edit_expense_group.desc"
              :rules="[$rule.length({max: 500})]"
              :counter="500"
              rows="1"
              auto-grow
              label="单据备注"
              placeholder="备注信息..."
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div
              style="position: relative;min-height: 18px;"
            >
              <span
                class="v-label v-label--active theme--light"
                style="position: absolute; top: 0; left: 0; transform-origin: top left; display: inline-block; transform: scale(0.75)"
              >
                上传附件
              </span>
            </div>
            <EditAttachments
              :files="edit_expense_group.bfiles"
              model_type="ExpenseGroup"
              :model_id="edit_expense_group.id"
            />
            <FileUploader 
              :validate-file="validateFile"
              @uploaded="attachmentUploaded"
            />
            <span class="color-error">为保证兼容性，办公文档请上传office系列(Word, Excel, PPT)</span>
          </v-col>
        </v-row>
        <v-row v-if="Number(type)===9">
          <v-col>
            <Tfjc
              ref="ads"
              v-model="edit_expense_group"
              :refresh="config.modal"
              have-paid-amountitle="本次账单金额"
              have-paid-amountitle-total="本次账单金额总计："
            />
          </v-col>
        </v-row>
        <!-- expenses -->
        <div
          v-if="edit_expense_group.expenses && edit_expense_group.expenses.length"
          class="expenses-container"
        >
          <v-btn
            style="margin-left:10px"
            color="primary"
            small
            @click="upload"
          >
            <!-- @click="calSum(expense)" -->
            导入
          </v-btn>
          <a
            style="margin-left:10px;font-size:10px"
            href="/static/files/批量导入分团队的数据模板.xlsx"
            target="_blank"
          >
            模版下载
          </a>
          <div
            v-for="(expense, ei) in edit_expense_group.expenses"
            :key="ei"
            class="expense-wrapper"
          >
            <v-row>
              <v-col>
                <v-text-field
                  v-model="expense.name"
                  :rules="[v => !!v || '名称不能为空', $rule.length({max: 50})]"
                  :counter="50"
                  :label="`项目${ei + 1}`"
                  placeholder="请简要描述事项"
                />
              </v-col>
              <v-col>
                <v-text-field
                  v-model="expense.price"
                 
                  :rules="[v => $util.isNumber(v) || '请输入正确的金额格式', _ => expensePriceValid(expense) || '分配金额不等于项目总额']"
                  :label="`项目${ei + 1}-金额`"
                  type="number"
                  placeholder="金额..."
                  @input="()=>changeMoney(expense)"
                >
                  <template v-slot:append-outer>
                    <v-tooltip top>
                      <template v-slot:activator="{on,attrs}">
                        <v-btn
                          fab
                          dark
                          x-small
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                          @click="calSum(expense)"
                        >
                          <v-icon>
                            mdi-calculator
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>分配金额求和</span>
                    </v-tooltip>
                  </template>
                  <v-text-field />
                </v-text-field>
              </v-col>
            </v-row>
            <div v-if="is_financer || is_exec">
              <v-btn
                v-if="!expense.expense_teams|| !expense.expense_teams.length"
                @click="addNewExpenseTeam(expense.expense_teams)"
              >
                添加
              </v-btn>
              <v-row
                v-for="(et, eti) in expense.expense_teams"
                :key="eti"
                style="padding-left: 10px"
              >
                <v-col cols="3">
                  <VTeamSelector
                    v-model="et.team_id"
                    :rules="[v => v > 0 || '请选择团队']"
                    :label="`团队分配${eti+1}`"
                    placeholder="选择分配团队"
                    append-icon="mdi-calculator-variant"
                    @click:append="fillExpenseTeamInfo(expense, et, eti)"
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="et.price"
                    :rules="[v => $util.isNumber(v) || '请输入正确的金额格式']"
                    label="金额"
                    type="number"
                    placeholder="金额..."
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="et.desc"
                    :rules="[$rule.length({max: 500})]"
                    :counter="500"
                    label="分配备注"
                    placeholder="备注..."
                  />
                </v-col>
                <v-col
                  cols="2"
                  style="padding-top: 25px"
                >
                  <v-btn
                    v-if="(eti === expense.expense_teams.length - 1)&&!is_period_closed"
                    fab
                    dark
                    x-small
                    color="primary"
                    style="margin-right: 5px"
                    @click="addNewExpenseTeam(expense.expense_teams)"
                  >
                    <v-icon dark>
                      mdi-plus
                    </v-icon>
                  </v-btn>
                  <v-btn
                    v-if="expense.expense_teams.length > 1&&!is_period_closed"
                    fab
                    dark
                    x-small
                    color="orange"
                    @click="deleteExpenseTeam(expense.expense_teams, et, eti)"
                  >
                    <v-icon dark>
                      mdi-minus
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </div>
            <v-row v-if="is_financer">
              <!-- :rules="[v => v > 0 || '请选择']" -->
              <v-col v-if="type!==9">
                <VExpenseTypeSelector
                  v-model="expense.expense_type_id"
                  :clearable="true"
                  label="费用类型"
                  placeholder="请选择"
                />
              </v-col>
              <v-col v-if="!is_advance_or_recharge">
                <VExpenseInvoiceInfoEditor :expense="expense" />
              </v-col>
            </v-row>
            <ExpenseTitleEditor
              v-if="need_account_and_analysis_title"
              :expense="expense"
            />
            <v-row>
              <v-col>
                <v-textarea
                  v-model="expense.desc"
                  :rules="[$rule.length({max: 500})]"
                  :counter="500"
                  rows="1"
                  auto-grow
                  :label="`项目${ei + 1}-备注`"
                  placeholder="备注信息..."
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col v-if="isLastExpense(ei)&&!is_period_closed">
                <v-btn
                  color="primary"
                  block
                  @click="addNewExpense()"
                >
                  <v-icon>mdi-plus</v-icon>
                  添加项目
                </v-btn>
              </v-col>
              <v-col v-if="edit_expense_group.expenses.length > 1&&!is_period_closed">
                <v-btn
                  color="orange"
                  block
                  @click="deleteExpense(expense, ei)"
                >
                  <v-icon>mdi-close</v-icon>
                  删除项目{{ ei+1 }}
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </div>

        <v-btn
          v-else-if="!isLastExpense(ei)&&!is_period_closed"
          block
          color="primary"
          @click="addNewExpense"
        >
          <v-icon>mdi-plus</v-icon>
          新建项目
        </v-btn>
      </v-form>
    </VModal>
  </div>
</template>
<script>
  import moment from 'moment'
  import {mapGetters} from "vuex";
  import ExpenseGroupUtil from '../libs/util'
  import FlowUtil from '../../../libs/flow_util';
  import ExpenseUtil, {createExpense, createExpenseTeam} from '../../../libs/expense_util';
  import VModal from '../../../vuetify_custom/v-modal_v1';
  import EditHeader from './editor/header';
  import VTeamSelector from '../../team/components/v-selector';
  import VCustomerSelector from '../../components/customer/v-selector';
  import VContractSelector from '../../contract/components/v-selector';
  import VOutsourceContractSelector from '../../outsource/components/v-selector';
  import VAdvanceSelector from '../../expense_group/components/v-advance-selector';
  import VReturnSelector from '../../expense_group/components/v-return-selector';
  import VBankSelector from '../../expense_group/components/v-bank-selector';
  import VDatePicker from '../../../vuetify_custom/v-date-picker';
  import VPayeeAccountSelector from '../../payee_company/components/v-account-selector';
  import VExpenseTypeSelector from '../../expense_type/components/v-selector';
  import VExpenseInvoiceInfoEditor from '../../invoice/components/v-expense-invoice-info-editor';
  import ExpenseTitleEditor from './editor/expense_title';
  import InvoiceRegisterInfo from './invoice_register_info'
  import FileUploader from '../../components/file/uploader';
  import EditAttachments from '../../components/file/edit_attachments';
  import ViewerItem from '../../components/viewer/item';
  import ReimbursementInfo from './reimbursement_info';
  import Tfjc, {getPlacingAdsRecordsSumMixins} from '@/views/mine/components/fk_modal/TFJC'
  import { getContractDetailApi, getPlacingAdsRecordApi, getPlacingAdsVasRecordApi, importDataApi } from '@/views/mine/components/fk_modal/service.js'
  // import BlogTips from '@/views/mine/components/fk_modal/BlogTips.vue'
  import { getsafe } from '@/libs/util.js'
  import util_api, { formattingNumber } from '@/libs/util'
  const { 
    expense_group_overflow_price
  } = util_api.api || {}
  function getSmallVerifiedAt(arr, key, v) {
    arr = arr || []
    arr.forEach(item => {
      if (!v || v > item[key]) {
        v = item[key]
      }
    })
    return v
  }
  export default {
    components: { VModal, EditHeader, VCustomerSelector, VContractSelector, VOutsourceContractSelector,
                  VAdvanceSelector, VReturnSelector, VBankSelector, VDatePicker, VPayeeAccountSelector,
                  VExpenseTypeSelector, VExpenseInvoiceInfoEditor, VTeamSelector, ExpenseTitleEditor,
                  ReimbursementInfo, FileUploader, EditAttachments, ViewerItem, InvoiceRegisterInfo, Tfjc },
    mixins: [getPlacingAdsRecordsSumMixins],
    props: {
      // 付款类型, 对应 payment_type
      type: {
        type: Number
      },
      /*
      * 编辑角色
      * staff: 普通员工
      * financer: 财务人员, 可编辑所有内容
      * */
      role: {
        type: String,
        default: 'staff'
      },
      payeeFindKey: {
        type: String,
        default: 'search'
      },
      payeeNoDataText: {
        type: String,
        default: '没有数据，请搜索'
      },
    },
    data() {
      this.datePickerOptions = {
        disabledDate(date) {
          return date && date.valueOf() < +new Date();
        }
      }
      this.handle_list = null
      
      return {
        is_period_closed: false,
        data_valid: true,
        reimbursement_menu: false,
        loading: false,
        config: {
          modal: false,
          loading: false
        },
        // 请与 contract / expense_group 中 kind 定义保持一致
        kinds: [
          {value: 'yunzhanghu', label: '云账户'},
          {value: 'shebao51', label: '51社保'},
        ],
        edit_expense_group:{...ExpenseUtil.new_expense_group, ...ExpenseUtil.setPlaceArr()},
        new_expense: ExpenseUtil.new_expense,
        new_expense_team: ExpenseUtil.new_expense_team,
        title_error_msg: '请通过选择合适的 费用 Nature 等选项，匹配出会计科目和分析科目'
      }
    },
    computed: {
      is_type_9() {
        return this.type === 9
      },
      // show_blog_tips() {
      //   if (!this.edit_expense_group ||
      //     (!this.edit_expense_group.ads_record_ids &&
      //       !this.edit_expense_group.ads_vas_record_ids)
      //   ) {
      //     return false
      //   } 
       
      //   return (!!this.edit_expense_group.ads_record_ids && this.edit_expense_group.ads_record_ids.length) || 
      //     (!!this.edit_expense_group.ads_vas_record_ids && this.edit_expense_group.ads_vas_record_ids.length)
      // },
      vpayeeaccountselector_item_text() {
        if (this.type === 1) { // 业务申请/处理 / 付款申请
          return (i) => {
            return (`${i.bank_number}-${i.payee_company_name}${i.remark && `-${i.remark}` || ''}`)
          } // (`${i.bank_number}-${i.payee_company_name}-${i.remark}`)
        }
        return undefined
      },
      new_expense_group() {
        if (Number(this.type) === 9) {
          return {...ExpenseUtil.new_expense_group, ...ExpenseUtil.setPlaceArr()}
        }
        return ExpenseUtil.new_expense_group;
      },
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      kind_values() {
        return this.kinds.map((k) => (k.value))
      },
      payment_type() {
        return this.edit_expense_group.payment_type;
      },
      payee_account_info() {
        const eg = this.edit_expense_group;
        if (eg.payee_bank_number) {
          return `${eg.payee_bank_number}-${eg.payee_account_name}-${eg.payee_bank}`
        }
        return '请选择对方收款账户';
      },
      ...mapGetters('async', {
        expense_types: 'expense_types',
        expense_types_hash: 'expense_types_hash',
        companies: 'companies',
        companies_hash: 'companies_hash',
        teams: 'root_teams',
        teams_hash: 'root_teams_hash',
        currencies_remote: 'currencies'
      }),
      currencies() {
        return ExpenseUtil.currencies;
      },
      currencies_hash() {
        return ExpenseUtil.currencies_hash;
      },
      expense_group_company() {
        const company = this.companies_hash[this.edit_expense_group.company_id];
        return company ? company.short_name : '-';
      },
      expense_group_team() {
        const team = this.teams_hash[this.edit_expense_group.team_id];
        return team ? team.name : '-';
      },
      total_price() {
        let total_price = 0;
        if (this.can_edit && this.edit_expense_group.expenses) {
          this.edit_expense_group.expenses.forEach((expense) => {
            if (this.$util.isNumber(expense.price)) {
              total_price = math.eval(`${expense.price} + ${total_price}`).toFixed(2);
            }
          });
          if (this.edit_expense_group.advance && this.edit_expense_group.advance.id) {
            total_price = math.eval(`${total_price} - ${this.edit_expense_group.advance.total_price}`).toFixed(2)
          }
          return total_price;
        } else {
          return this.edit_expense_group.total_price;
        }
      },
      is_advance_or_recharge() {
        return [2, 3].indexOf(this.payment_type) > -1;
      },
      // 是否为计提修正单, 计提修正单部分内容不能更改
      is_accrual_repair() {
        return this.payment_type === 6;
      },
      // 编辑角色是否为"财务人员"
      is_financer() {
        return this.role === 'financer' || (this.cur_customer.groups && this.cur_customer.groups.indexOf('GROUP_FIN') > -1);
      },
      // 是否为行政人员, 行政可以按团队分配
      is_exec() {
        return this.cur_customer.groups && this.cur_customer.groups.indexOf('GROUP_EXEC') > -1;
      },
      // 是否可以关联合同
      can_link_contract() {
        return [0, 2, 5, 6].indexOf(this.payment_type) === -1 && !this.edit_expense_group.is_outsource;
      },
      can_link_outsource_contract() {
        return [1, 3, 7].indexOf(this.payment_type) > -1;
      },
      can_link_return_bill() {
        return this.need_pay && math.eval(`${this.total_price} < 0`);
      },
      need_pay() {
        return [0, 1, 2, 3].indexOf(this.payment_type) > -1;
      },
      need_account_and_analysis_title() {
        return this.is_financer && [0, 1, 2, 8, 9].indexOf(this.payment_type) > -1;
      },
      payee_type() {
        return ExpenseUtil.getPayeeType(this.edit_expense_group);
      },
      can_edit() {
        return FlowUtil.inEditNode(this.edit_expense_group);
      },
    },
    watch: {
      cur_customer() {
        this.setDefaultValues();
      },
      edit_expense_group: {
        handler() {
          this.autoCheckValid();
        },
        deep: true
      }
    },
    created() {
      this.edit_expense_group = this.$util.clone(this.new_expense_group);
      this.init();
    },
    mounted() {
   
      //
    },
    methods: {
      generateFromAccount(target) {
        const new_expense_group = this.$util.clone(this.new_expense_group)
    
      
        const contract_id = getsafe(target, 'contract.id', {})
        const team_id = getsafe(target, 'team_id')
        new_expense_group.contract_id = contract_id
        new_expense_group.expenses[0].price = getsafe(target, 'total', 0)
        new_expense_group.expenses[0].expense_teams[0].price = getsafe(target, 'total', 0)
        new_expense_group.expenses[0].expense_teams[0].team_id = team_id
        new_expense_group.total_price = getsafe(target, 'total', 0)
        this.$set(this, 'edit_expense_group', new_expense_group);
        this.init();
      
        this.config.modal = true
      },
      validTotal(val) {
        const has_placing_ads_records = this.edit_expense_group.placing_ads_records && this.edit_expense_group.placing_ads_records.length
        const has_placing_ads_vas_records = this.edit_expense_group.placing_ads_vas_records && this.edit_expense_group.placing_ads_vas_records.length
        if (!has_placing_ads_records && !has_placing_ads_vas_records) {
          return true
        }
        return Number(val) === Number(this.getPlacingAdsRecordsSum(this.edit_expense_group)) || '投放记录与加成服务的金额需与总金额相等'
      },
      upload() {
    
        this.el = document.createElement('input')
        this.el.setAttribute('type', 'file')
        this.el.style.display = 'none'
        this.$refs.contain.appendChild(this.el)
        this.el.click()
        this.el.addEventListener('change', () => {
          const file = this.el.files[0]
          if (file && ['xlsx', 'csv', 'xls', 'excel', 'spreadsheetml.sheet'].some(item => {
            return file.type.includes(item)
          })) {// 符合格式
            const params = new FormData()
            params.append('datafile', file)
          
            this.saving = true
            
            importDataApi(params).then((res) => {
              res = res || []
              this.edit_expense_group.expenses = []
              res.forEach(item => {
                const o = createExpense()    
                o.name = item.name
                o.expense_teams = (item.expense_teams || []).map(i => {
                  return {
                    ...createExpenseTeam(),
                    ...i
                  }
                })
                if (o.expense_teams.length === 0) {
                  o.expense_teams = [createExpenseTeam()]
                }
                this.edit_expense_group.expenses.push(o)
              });
              if (!this.edit_expense_group.expenses.length) {
                this.edit_expense_group.expenses = [createExpense()]
              }
              this.$Message.success('上传成功！')
            }).finally(() => {
              this.saving = false
              this.el && this.el.removeEventListener && this.el.removeEventListener('change', this.uploadFile)
            })
            return 
          } 
          this.$Message.error('不支持该格式！')
        })
      },
      selectConctract(data) {
        if (Number(this.type) !== 9) {
          return 
        }
        this.edit_expense_group.tfjc_type = 0
        if (!this.edit_expense_group.accrued) {
          this.edit_expense_group.placing_ads_records = []
          this.edit_expense_group.placing_ads_vas_records = []
        }
        if (data.id && !this.edit_expense_group.accrued) {
          getContractDetailApi({id:data.id}).then(() => {
            const params = { query_all:this.is_financer,
                             relate_type: 'payment_bill',
                             contract_type:  'Contract',
                             contract_id: data.id}
            setTimeout(() => {
              getPlacingAdsRecordApi(params).then(res => {
                res = res || []
                this.edit_expense_group.placing_ads_records = res.map(i => {
                  return {
                    ...i,
                    have_paid_amount: Number(i.payable_price) || Number(i.total_price) - Number(i.paid_price) || 0
                  }
                })
              })
              getPlacingAdsVasRecordApi(params).then(res => {
                res = res || []
                this.edit_expense_group.placing_ads_vas_records = res
              })
            })
          })
        }
      },
      generateFromBlog(data) {
        const new_expense_group = this.$util.clone(this.new_expense_group)
        let verified_at = null
        if (data) {
          Object.keys(data).forEach(key => {
            new_expense_group[key] = data[key]
          })
        
        }
        if (new_expense_group.ytd_ads_record_ids) {
          //  new_expense_group.ytd_ads_record_ids = new_expense_group.ytd_ads_record_ids
          new_expense_group.accrued = true
          verified_at = moment().endOf("month").format('YYYY-MM-DD')
          // paid_price
          let total_price = 0
          let team_hash = null

          new_expense_group.ytd_ads_record_ids.forEach(item => {
            const price = Number(item.payable_price) || Number(item.total_price) - Number(item.paid_price) || 0
            total_price = math.eval(`${total_price || 0}+${price || 0}`)
            if (!team_hash || !team_hash[item.team_id]) {
              if (!team_hash) {
                team_hash = {}
              }
              team_hash[item.team_id] = {
                desc: "",
                expense_id: 0,
                price: 0,
                team_id: item.team_id,
              }
            }
            team_hash[item.team_id].price = math.eval(`${ team_hash[item.team_id].price}+${price || 0}`).toNumber()
          })
          if (total_price.toNumber) {
            total_price = total_price.toNumber()
          }
          new_expense_group.total_price = total_price
          new_expense_group.expenses[0].price = total_price
          if (team_hash) {
            new_expense_group.expenses[0].expense_teams = Object.values(team_hash)
          }
        }
      
    
        Object.keys(data).forEach(key => {
          if (['ads_record_ids', 'ads_vas_record_ids'].includes(key)) {
            const data_key = key === 'ads_record_ids' ? 'publish_at' : 'service_date'
            verified_at = getSmallVerifiedAt(data[key], data_key, verified_at)
            return 
          }
        })
        let contract = null
        if (new_expense_group.ytd_ads_record_ids) {
          new_expense_group.tfjc_type = 0  
          new_expense_group.placing_ads_records = new_expense_group.ytd_ads_record_ids.map(i => ({
            ...i,
            have_paid_amount: Number(i.payable_price) || Number(i.total_price) - Number(i.paid_price) || 0
          }))
         
        } else if (data.ads_record_ids && data.ads_record_ids.length) {
          new_expense_group.tfjc_type = 0  
          new_expense_group.placing_ads_records = data.ads_record_ids.map(i => ({
            ...i,
            have_paid_amount: Number(i.payable_price) || Number(i.total_price) - Number(i.paid_price) || 0
          }))
          new_expense_group.placing_ads_records.forEach(i => {
            contract = i.placing_ads_contract
          })
        } else if (data.ads_vas_record_ids && data.ads_vas_record_ids.length) {
          new_expense_group.tfjc_type = 0  
          new_expense_group.placing_ads_vas_records = data.ads_vas_record_ids
          new_expense_group.placing_ads_vas_records.forEach(i => {
            contract = i.placing_ads_contract
          })
        }
        if (contract) {
          new_expense_group.contract_id = contract.contract_id
        }
        new_expense_group.ytd_ads_record_ids = undefined
        this.$set(this, 'edit_expense_group', new_expense_group);
        this.init();
        this.edit_expense_group.verified_at = verified_at
        this.config.modal = true
      },
      changeMoney(data) {
        if (data && Number(data.invoice_type) === 1) {
          let tax = (Number(data.price) || 0) * (Number(data.tax_rate) || 0)
          tax = Number(tax.toFixed(2)) 
          data.tax = tax
        }
      },
      validateFile(file) {
        const a = /\.[0-9a-zA-Z]+$/.test(file.name)
        if (!a) {
          this.$vModal.warning({
            title:'提示',
            content:'文件格式错误，无法解析。建议上传如下类型：.xlsx、.pdf等带有后缀的'
          })
        }
        return a
      },
      calSum(item) {
        let sum = 0
        item.expense_teams.forEach(item => {
          sum += (Number(item.price) || 0)
        })
        sum = Number(sum.toFixed(2))
        item.price = sum
        this.changeMoney(item)
      },
      init() {
        this.edit_expense_group.payment_type = this.type;
        this.setDefaultValues();
      },
      setDefaultValues() {
        const customer = this.cur_customer;
        if (customer && customer.id) {
          this.edit_expense_group.team_id = customer.root_team_id;
          this.setFillUser(customer);
          this.setApplyUser(customer);
        }
      },
      edit(expense_group) { // 20200818
        /*   if (this.type === 8) {
          this.config.modal = true;
          const id = expense_group && expense_group.id
          getDetail(id).then((res) => {
            console.log('res', res)
          })
          return 
        } */
        this.is_period_closed = false
        this.config.modal = true;
        if (expense_group) {
          if (expense_group.gen_by_contract) { // 如果是从合同跳转到账单提交单
            // 添加
            //const { gen_by_contract, ...other } = expense_group
            // 这里expense_group对象的value，都是基本值，如果后续value中含有引用类型的值，这里需要进一步diff处理
            this.$set(this, 'edit_expense_group', this.$util.clone(this.new_expense_group));
            setTimeout(() => {
              // 因为init 中有比较复杂的逻辑，在这里直接异步赋值
              Object.keys(expense_group).forEach(key => {
                this.edit_expense_group[key] = expense_group[key]
              })
            }, 50)
            this.init();
            return 
          }
          if (expense_group.id) {
            // 编辑
            this.loading = true;
            ExpenseGroupUtil.getDetail(expense_group.id).then((data) => {     
              this.$set(this, 'edit_expense_group', data.expense_group);
              switch (this.type) {
              case 9: // 账单提交单
              case 0: // 费用报销
              case 8: // 发票提交
                this.is_period_closed = !!data.expense_group.period_closed
                break;
              
              default:
                break;
              }
            
            }).catch(() => {
              this.$Message.error('获取数据失败, 请重试!');
              this.config.modal = false;
            }).finally(() => {
              this.loading = false;
            });
          } else {
            // 复制 从合同跳转至账单提交
            this.$set(this, 'edit_expense_group', this.$util.clone(expense_group));
            this.init();
          }
        } else {
          // 添加
          this.$set(this, 'edit_expense_group', this.$util.clone(this.new_expense_group));
          this.init();
        }
      },
      copy(expense_group) {
        this.is_period_closed = false
        this.config.modal = true;
        this.loading = true;
        ExpenseGroupUtil.getDetail(expense_group.id).then((data) => {
          const old_expense_group = data.expense_group;
          const new_expense_group = this.$util.clone(ExpenseUtil.new_expense_group);
          const copy_columns = ['name', 'payment_type', 'contract_id', 'outsource_contract_id',
                                'has_stocks', 'is_simple', 'is_outsource', 'company_id', 'team_id', 'payee_bank',
                                'payee_account_name', 'payee_bank_number', 'payee_user', 'payee_user_id', 'payee_company',
                                'payee_company_id', 'payee_company_account_id', 'currency',
                                'total_price', 'purpose', 'desc', 'is_refund', 'return_expense_group_id',
                                'apply_user_id', 'apply_user'];
          copy_columns.forEach((column) => {
            new_expense_group[column] = old_expense_group[column];
          });
          if (old_expense_group.expenses && old_expense_group.expenses.length) {
            old_expense_group.expenses.forEach((expense, ei) => {
              const new_expense = this.$util.clone(ExpenseUtil.new_expense);
              new_expense.name = expense.name;
              new_expense.price = expense.price;
              new_expense.desc = expense.desc;
              expense.expense_teams.forEach((et, eti) => {
                const new_et = this.$util.clone(ExpenseUtil.new_expense_team);
                new_et.team_id = et.team_id;
                new_et.price = et.price;
                new_expense.expense_teams[eti] = new_et;
              });
              new_expense_group.expenses[ei] = new_expense;
            });
          }
          this.$set(this, 'edit_expense_group', new_expense_group);
          this.setFillUser(this.cur_customer);
        }).catch((e) => {
          console.log(e);
          this.$Message.error('获取数据失败, 请重试!');
          this.config.modal = false;
        }).finally(() => {
          this.loading = false;
        });
      },
      validateCurrency(rule, currency, callback) {
        const expense_group = this.edit_expense_group;
        if (!currency) {
          callback(new Error('请选择付款币别'));
        } else if (expense_group.advance_id) {
          const advance = expense_group.advance;
          if (advance.company_id !== expense_group.company_id) {
            const company = this.companies_hash[expense_group.company_id];
            const company_name = company ? company.name : '未选择';
            const advance_company = this.companies_hash[advance.company_id];
            const advance_company_name = advance_company ? advance_company.name : '未选择';
            callback(new Error(`报销单的所选公司(${company_name})应与预支单(${advance_company_name})相同`));
          } else if (advance.currency !== expense_group.currency) {
            const currency_name = ExpenseUtil.getCurrencyName(expense_group.currency);
            const advance_currency_name = ExpenseUtil.getCurrencyName(advance.currency);
            callback(new Error(`报销的付款币别(${currency_name})应与预支单(${advance_currency_name})相同`));
          } else {
            callback();
          }
        } else {
          callback();
        }
      },
      expensePriceValid(expense) {
        if (this.is_financer || this.is_exec) {
          let team_total = 0;
          if (this.$util.isNumber(expense.price)) {
            for (const et of expense.expense_teams) {
              if (!this.$util.isNumber(et.price)) return false;
              team_total = math.eval(`${et.price} + ${team_total}`).toFixed(2);
            }
            return math.eval(`${expense.price} == ${team_total}`);
          }
          return false;
        }
        return true;
      },
      autoCheckValid() {
        if (this.$refs.form) {
          this.$refs.form.validate();
        }
      },
      checkValid() {
        let err_msg = '';
        try {
          let total_price = 0;
          this.edit_expense_group.expenses.forEach((expense) => {
            total_price = math.eval(`${total_price} + ${expense.price}`).toFixed(2);
          });
          // 不能编辑时, 校验总金额是否与细项金额相等
          if (!this.can_edit) {
            if (this.edit_expense_group.advance.id) {
              total_price = math.eval(`${total_price} - ${this.edit_expense_group.advance.total_price}`).toFixed(2);
            }
            if (math.eval(`${this.edit_expense_group.total_price} != ${total_price}`)) {
              err_msg += `<p>[总金额] 不能更改, 如需更改, 请驳回至申请人.</p>`;
            }
          }
          if (err_msg) {
            this.$Modal.error({title: '错误提示', content: err_msg});
            return false;
          }
        } catch (e) {
          if (err_msg) {
            this.$Modal.error({title: '错误提示', content: err_msg});
          } else {
            this.$Modal.error({title: '错误提示', content: e.message});
          }
          return false;
        }
        return true;
      },
      updateExpenseGroupSubmit() {
        const expense_group = this.$util.clone(this.edit_expense_group);

        delete expense_group.advance;
        delete expense_group.accrual;
        delete expense_group.contract;
        delete expense_group.outsource_contract;
        delete expense_group.user_flow;
        if (Number(this.type) === 9) {
          //         tfjc_type: 0, // 0:投放记录；1:加成服务
          // placing_ads_records: [], // 投放记录
          // placing_ads_vas_records:[], // 加成服务
          expense_group.placing_ads_vas_records = expense_group.placing_ads_vas_records || []
          expense_group.placing_ads_vas_records = expense_group.placing_ads_vas_records.filter(i => !!i.id)
          expense_group.placing_ads_vas_records = expense_group.placing_ads_vas_records.map(i => {
            return {
              id:i.id,
              have_paid_amount:i.have_paid_amount
            }
          })
          expense_group.placing_ads_records = expense_group.placing_ads_records || []
          expense_group.placing_ads_records = expense_group.placing_ads_records.filter(i => !!i.id)
          expense_group.placing_ads_records = expense_group.placing_ads_records.map(i => {
            return {
              id:i.id,
              have_paid_amount:i.have_paid_amount
            }
          })
         
         
        }
   

        if (this.type === 9) {
          delete expense_group.expense_type_id;
        }
        if (this.payment_type === 2 && expense_group.expect_reverse_at) {
          expense_group.expect_reverse_at = this.$util.formatTime(expense_group.expect_reverse_at);
        } else {
          expense_group.expect_reverse_at = undefined
        }
        if (this.handle_list) {
          expense_group.statement_item_ids = this.handle_list.map(item => item.id)
        }
        this.config.loading = true
        this.$util.ajax.post(this.$util.api.update_expense_group, {...expense_group, total_price: this.total_price}).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const expense_group = res.data;
            this.$emit('update', expense_group);
            this.config.modal = false;
            this.$Message.success('保存成功!');
            this.handle_list = null
          } else {
            this.$Modal.error({title: '提示', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.error({title: '提示', content: e.message});
        }).finally(() => {
          this.config.loading = false
          //   this.resetEditLoading();
        });
      },
      updateExpenseGroupSubmitProxy() {
        // if (this.is_period_closed) {
        //   //  expense_group.payee_user_id = this.is_period_closed.payee_user_id 
        //   //  console.log('测试', isDiff({target:this.is_period_closed, source:expense_group}))
        //   this.$vModal.confirm({
        //     title:'提示',
        //     content: '当前账期已关闭，编辑过程只有“备注”字段可修改生效，其他字段信息修改无效，请知悉~',
        //     onOk:() => {
        //       this.updateExpenseGroupSubmit()
        //     }
        //   })
        //   return 
        // }
        this.updateExpenseGroupSubmit()
      },
      updateExpenseGroup() {
        let valid = this.$refs.form.validate();
        if (this.type === 9) {
          if (!this.$refs.ads.validate()) {
            valid = false
          }
        }
        if (!valid || !this.checkValid()) {
          this.$Message.error('表单有误');
          return
        }
        if (this.$router.currentRoute.path === '/fin/expense_group_company') {
          const {contract_id, id} = this.edit_expense_group
          this.config.loading = true
          this.$http.get(expense_group_overflow_price, {
            contract_id,
            total_price: Number(this.total_price), 
            id
          }).then((res) => {
            if (Number(res) > 0) {
              this.$vModal.confirm({
                title: '提示',
                content: `付款申请金额超过该合同可支付金额${formattingNumber(res, 2)}，请确认是否仍要提交！`,
                onOk:() => {
                  this.updateExpenseGroupSubmitProxy()
                }
              })
            } else {
              this.updateExpenseGroupSubmitProxy()
            }
          }).finally(() => {
            this.config.loading = false
          })
        
          // 
          return 
        }
        this.updateExpenseGroupSubmitProxy()
      },
      resetEditLoading() {
        this.config.loading = false;
        setTimeout(() => {
          this.config.loading = true;
        }, 500);
      },
      addNewExpense() {
        const new_expense = this.$util.clone(this.new_expense);
        if (new_expense.expense_teams.length === 0) {
          this.addNewExpenseTeam(new_expense.expense_teams);
        }
        this.edit_expense_group.expenses.push(new_expense);
      },
      deleteExpense(expense, index) {
        this.$Modal.confirm({
          title: '提示',
          content: '你确认要删除' + expense.name + '吗?',
          onOk: () => {
            if (expense.id) {
              this.$util.ajax.post(this.$util.api.delete_expense, {
                id: expense.id
              }).then((response) => {
                return response.data;
              }).then((res) => {
                if (res.code === 1) {
                  this.edit_expense_group.expenses.splice(index, 1);
                  this.$Message.success('删除成功!');
                } else {
                  this.$Modal.error({title: '提示', content: res.msg})
                }
              }).catch((e) => {
                this.$Modal.error({title: '提示', content: `删除失败: ${e.message}`})
              });
            } else {
              this.edit_expense_group.expenses.splice(index, 1);
            }
          }
        });
      },
      fillExpenseTeamInfo(expense, expense_team, index) {
        if (index === 0) {
          if (!expense_team.team_id) {
            expense_team.team_id = this.edit_expense_group.team_id;
          }
          expense_team.price = expense.price;
        } else {
          let total = 0;
          expense.expense_teams.forEach((et, i) => {
            if (index !== i) {
              total = math.eval(`${total} + ${et.price}`).toFixed(2);
            }
          });
          expense_team.price = math.eval(`${expense.price} - ${total}`).toFixed(2);
        }
      },
      addNewExpenseTeam(expense_teams) {
        if (!expense_teams) {
          this.$set(this.expense, 'expense_teams', [])
          expense_teams = this.expense.expense_teams
        }
        expense_teams.push(this.$util.clone(this.new_expense_team));
      },
      deleteExpenseTeam(expense_teams, expense_team, index) {
        this.$Modal.confirm({
          title: '提示',
          content: `你确认要删除吗?`,
          onOk: () => {
            if (expense_team.id) {
              this.$util.ajax.post(this.$util.api.delete_expense_team, {
                id: expense_team.id
              }).then((response) => {
                return response.data;
              }).then((res) => {
                if (res.code === 1) {
                  expense_teams.splice(index, 1);
                  this.$Message.success('删除成功!');
                } else {
                  this.$Modal.error({title: '提示', content: res.msg})
                }
              }).catch((e) => {
                console.log(e);
                this.$Modal.error({title: '提示', content: '删除失败'})
              });
            } else {
              expense_teams.splice(index, 1);
            }
          }
        });
      },
      attachmentUploaded(bfile) {
        this.edit_expense_group.bfiles.push(bfile);
      },
      companyChange(company_id) {
        const company = this.companies_hash[company_id];
        if (company && !this.edit_expense_group.currency) {
          this.edit_expense_group.currency = company.base_currency;
        }
      },
      isLastExpense(index) {
        return (index + 1) === this.edit_expense_group.expenses.length
      },
      getFillTime(edit_expense_group) {
        const time = edit_expense_group.created_at || new Date();
        return moment(time).format('YYYY-MM-DD');
      },
      setFillUser(customer) {
        this.edit_expense_group.fill_user_id = customer.id;
        this.edit_expense_group.fill_user = customer.account;
      },
      setApplyUser(customer) {
        this.edit_expense_group.apply_user_id = customer.id;
        this.edit_expense_group.apply_user = customer.account;
      },
      setBank(bank) {
        this.edit_expense_group.expense_payment_bank_id = bank.id;
        this.edit_expense_group.payment_bank_name = bank.bank;
        this.edit_expense_group.payment_bank_account = bank.account;
        this.edit_expense_group.payment_bank_number = bank.bank_number;
      },
      setPayeeAccount(account_obj) {
        Object.assign(this.edit_expense_group, account_obj);
      },
      setAdvance(advance) {
        if (advance.company_id !== this.edit_expense_group.company_id) {
          const advance_company = this.companies_hash[advance.company_id];
          const currency_company = this.companies_hash[this.edit_expense_group.company_id];
          const advance_company_name = advance_company ? advance_company.short_name : '未定义';
          const current_company_name = currency_company ? currency_company.short_name : '未定义';
          this.$Modal.error({title: '错误提示', content: `预支单公司(${advance_company_name})与报销单公司(${current_company_name})不一致`});
          return;
        }
        this.edit_expense_group.advance_id = advance.id;
        this.edit_expense_group.advance = advance;
      },
      handleCreateBill({list, type}) { // 手动生成付款单 银行流水
        this.edit_expense_group.expense = this.$util.clone(ExpenseUtil.new_expense_group).expense
        const company_id = new Set()
        const transaction_date = new Set()
        const opposite_account_name = new Set()
        const opposite_bank_name = new Set()
        const opposite_bank_number = new Set()
        let bank_number = ''
        const price = list.reduce((total, item) => {
          let amount = 0
          if (item.debit_credit_flag === 'debit') { // 借款单
            amount += (Number(item.debit_amount) || 0)
          } else { // 贷款单
            amount -= (Number(item.credit_amount) || 0)
          }
          return total + amount
        }, 0)
        list.forEach(item => {
          company_id.add(item.company_id)
          transaction_date.add(item.transaction_date)
          opposite_account_name.add(item.opposite_account_name)
          opposite_bank_name.add(item.opposite_bank_name)
          opposite_bank_number.add(item.opposite_bank_number)
          bank_number = item.bank_number
        })
        this.edit_expense_group.payment_type = 1
        this.edit_expense_group.company_id = company_id.size === 1 ? company_id.get(0) : ''
        this.edit_expense_group.paid_at = transaction_date.size === 1 ? transaction_date.get(0) : ''
        this.edit_expense_group.payee_account_name = opposite_account_name.size === 1 ? opposite_account_name.get(0) : ''
        this.edit_expense_group.payee_bank = opposite_bank_name.size === 1 ? opposite_bank_name.get(0) : ''
        this.edit_expense_group.payee_bank_number = opposite_bank_number.size === 1 ? opposite_bank_number.get(0) : ''
        for (let i = 0, len = this.companies.length; i < len; i++) {
          if (this.companies[i].id === this.edit_expense_group.company_id) {
            this.edit_expense_group.currency = this.companies[i].base_currency
            break
          }
        }
        /* 付款账户 */
        this.edit_expense_group.payment_bank_number = bank_number
        /* 项目 相关 */
        this.edit_expense_group.expenses[0].name = '手动生成付款单'
        this.edit_expense_group.expenses[0].price = type === 'receipt' ? 0 - Number(price.toFixed(2)) : Number(price.toFixed(2))
        /* 是简易付款 */
        this.edit_expense_group.is_simple = true
        /* 表明入口是手动生成付款单 */
        this.handle_list = list
        this.is_period_closed = false
        this.config.modal = true
        // ExpenseUtil.getPayeeType(this.edit_expense_group)
        // 反查
        this.$util.ajax.get('/payee_company/query_account', {
          params: this.params
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data.payee_companies || [];
            for (let i = 0; i < data.length; i++) {
              const payee_company_accounts = data[i].payee_company_accounts
              for (let j = 0; j < payee_company_accounts.length; j++) {
                if (this.edit_expense_group.payee_bank_number === payee_company_accounts[j].bank_number) {
                  this.$refs.payeeAccountSelector.setPayeeCompany(data[i], payee_company_accounts[j])
                  return
                }
              }

            }
          } else {
            this.$Modal.warning({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.warning({title: '错误', content: e.message});
        })

        this.handleGet({bank_number})
      },
      // 手动生成付款单 获取付款账户
      handleGet(data) {
        // setBank this.edit_expense_group.company_id bank_number
        const _this = this
        this.$util.ajax.get(this.$util.api.get_expense_payment_banks, {
          params: {}
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            for (const value of res.data) {
              if (data.bank_number === value.bank_number) {
                _this.setBank(value)
              }
            }
          }
        })
      },
      closeModal() {
        this.handle_list = null
        this.edit_expense_group = this.$util.clone(this.new_expense_group);
        this.is_period_closed = false
        this.$emit('cancel')
      }
    }
  }
</script>
